import {
  UndoReactionMutation,
  UndoReactionMutationVariables,
  useUndoReactionMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';
import { useCurrentIdentity } from '@spotify/plugin-confidence-iam-react';

import { undoReactionCacheUpdate } from './undo-reaction-cache-update';

const useUndoReactionImpl = withStandardMutationHook<
  UndoReactionMutation,
  undefined,
  UndoReactionMutationVariables,
  'undoReaction'
>(useUndoReactionMutation, 'undoReaction');

export const useUndoReaction: typeof useUndoReactionImpl = options => {
  const { currentIdentity } = useCurrentIdentity();

  return useUndoReactionImpl({
    ...options,
    update: undoReactionCacheUpdate(currentIdentity),
  });
};
